<template>
    <div class="mh-100 h-100 position-relative">
        <div class="secondary-nav justify-content-end">
            <div class="d-flex justify-content-between w-100">
                <div class="align-items-center d-flex gap-10 w-100 justify-content-center margin-left-76">
                    <svg
                        :class="{
                            'cursor-pointer': zoom > 0.25,
                            disabled: zoom <= 0.25,
                        }"
                        @click="handleDecreaseZoom"
                        :opacity="zoom === 0.25 ? 0.5 : 1"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect x="0.5" y="0.5" width="29" height="29" rx="4.5" fill="#383838" />
                        <rect x="0.5" y="0.5" width="29" height="29" rx="4.5" stroke="#595959" />
                        <path
                            d="M24.9001 13.65V16.35C24.9001 16.725 24.7688 17.0438 24.5063 17.3063C24.2438 17.5688 23.9251 17.7 23.5501 17.7H6.4501C6.0751 17.7 5.75635 17.5688 5.49385 17.3063C5.23135 17.0438 5.1001 16.725 5.1001 16.35V13.65C5.1001 13.275 5.23135 12.9563 5.49385 12.6938C5.75635 12.4313 6.0751 12.3 6.4501 12.3H23.5501C23.9251 12.3 24.2438 12.4313 24.5063 12.6938C24.7688 12.9563 24.9001 13.275 24.9001 13.65Z"
                            fill="#E8EAED"
                        />
                    </svg>

                    {{ this.zoomLevel }}
                    <svg
                        :class="{
                            'cursor-pointer': zoom < 3.75,
                            disabled: zoom >= 3.75,
                        }"
                        @click="handleIncreaseZoom"
                        :opacity="zoom === 3.75 ? 0.5 : 1"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect x="0.5" y="0.5" width="29" height="29" rx="4.5" fill="#383838" />
                        <rect x="0.5" y="0.5" width="29" height="29" rx="4.5" stroke="#595959" />
                        <path
                            d="M24 13.7727V16.2273C24 16.5682 23.8807 16.858 23.642 17.0966C23.4034 17.3352 23.1136 17.4545 22.7727 17.4545H17.4545V22.7727C17.4545 23.1136 17.3352 23.4034 17.0966 23.642C16.858 23.8807 16.5682 24 16.2273 24H13.7727C13.4318 24 13.142 23.8807 12.9034 23.642C12.6648 23.4034 12.5455 23.1136 12.5455 22.7727V17.4545H7.22727C6.88636 17.4545 6.59659 17.3352 6.35795 17.0966C6.11932 16.858 6 16.5682 6 16.2273V13.7727C6 13.4318 6.11932 13.142 6.35795 12.9034C6.59659 12.6648 6.88636 12.5455 7.22727 12.5455H12.5455V7.22727C12.5455 6.88636 12.6648 6.59659 12.9034 6.35795C13.142 6.11932 13.4318 6 13.7727 6H16.2273C16.5682 6 16.858 6.11932 17.0966 6.35795C17.3352 6.59659 17.4545 6.88636 17.4545 7.22727V12.5455H22.7727C23.1136 12.5455 23.4034 12.6648 23.642 12.9034C23.8807 13.142 24 13.4318 24 13.7727Z"
                            fill="#E8EAED"
                        />
                    </svg>
                </div>
                <router-link
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                    :to="{ name: 'JobCanvas', params: { uuid: id } }"
                >
                    <button class="btn-back btn text-white font-weight-bold" @click="navigate">
                        <i class="fa lh-inherit fa-chevron-left"></i> {{ 'Back' | trans }}
                    </button>
                </router-link>
            </div>
        </div>
        <div class="main-image-container">
            <div class="mh-100 h-100">
                <div class="gallery-1 overflow-hidden">
                    <div class="gallery-row d-flex justify-content-center">
                        <canvas
                            @mousedown="onPointerDown"
                            @touchstart="handleTouch($event, onPointerDown)"
                            @mouseup="onPointerUp"
                            @touchend="handleTouch($event, onPointerUp)"
                            @mousemove="onPointerMove"
                            @touchmove="handleTouch($event, onPointerMove)"
                            @wheel="handleZoom($event)"
                            @dblclick="handleZoomOnDbClick"
                            id="viewport"
                            ref="canvas"
                        ></canvas>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 d-flex justify-content-center">
            <div class="carousel-container w-75 d-flex justify-content-center">
                <div class="w-75 d-flex carousel-sub-container">
                    <div
                        @click="previousImage"
                        class="d-flex align-items-center justify-content-center go-to-image"
                        :class="{
                            'cursor-pointer': currentIndex > 0,
                            disabled: currentIndex <= 0,
                        }"
                    >
                        <i class="fa fa-chevron-left" :class="currentIndex > 0 ? 'text-white' : 'disbaled-icon'"></i>
                    </div>
                    <div class="d-flex carousel-image-container">
                        <div
                            v-for="(image, index) in currentJob.base64_output_images"
                            :key="index"
                            v-if="handleImagesToShow(index)"
                            :class="currentIndex === index ? 'active-image' : 'inactive-image'"
                            class="image cursor-pointer carousel-image-sub-container"
                            @click="
                                currentIndex = index;
                                loadNewImage();
                            "
                        >
                            <img class="carousel-image" :src="image" />
                        </div>
                    </div>
                    <div
                        @click="nextImage"
                        class="d-flex align-items-center justify-content-center go-to-image"
                        :class="{
                            'cursor-pointer': currentIndex < currentJob.base64_output_images.length - 1,
                            disabled: currentIndex >= currentJob.base64_output_images.length - 1,
                        }"
                    >
                        <i
                            class="fa fa-chevron-right"
                            :class="
                                currentIndex < currentJob.base64_output_images.length - 1
                                    ? 'text-white'
                                    : 'disbaled-icon'
                            "
                        ></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';

export default {
    name: 'SelectedImageCanvas',
    props: {},
    components: {},
    mixins: [store, currentJob],
    data() {
        return {
            imageSrc: '',
            firstIndex: 0,
            lastIndex: 4,
            currentIndex: 0,
            zoomSpeed: 0.05,
            cameraOffset: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
            zoom: 1,
            MAX_ZOOM: 3.75,
            MIN_ZOOM: 1,
            SCROLL_SENSITIVITY: 0.0005,
            isDragging: false,
            dragStart: { x: 0, y: 0 },
        };
    },
    beforeMount() {
        window.addEventListener('keydown', this.handleKeydown, null);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleKeydown);
    },
    mounted: function () {
        const canvas = this.$refs.canvas;
        const image = new Image();
        image.src = this.currentJob.base64_output_images[this.currentIndex];
        image.onload = () => {
            this.cameraOffset.x = window.innerWidth / 2;
            this.cameraOffset.y = window.innerHeight / 2.5;
            //this is set to 0.75 by default to give room for carousel
            //check zoomLevel()
            this.zoom = 0.75;
            this.draw(image);
        };

        //Since watcher is not called when currentIndex is 0
        if(this.currentIndex === 0){
            this.handleImageGalleryIndex(0)
        }
    },
    created: function () {
        this.currentIndex = this.$route.params.selected_image;
        if (this.currentIndex > 3) {
            this.lastIndex = this.currentIndex + 2;
            this.firstIndex = this.currentIndex - 2;
        }
    },
    watch: {
        currentIndex(newValue, oldValue) {
            this.handleImageGalleryIndex(newValue)
        },
    },
    methods: {
        draw(image) {
            const canvas = this.$refs.canvas;
            const ctx = canvas?.getContext('2d');
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;

            ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

            // Translate to the canvas centre before zooming
            ctx.translate(window.innerWidth / 2, window.innerHeight / 2);
            ctx.scale(this.zoom, this.zoom);
            ctx.translate(-window.innerWidth / 2 + this.cameraOffset.x, -window.innerHeight / 2 + this.cameraOffset.y);

            ctx.drawImage(image, -image.width / 2, -image.height / 2);

            requestAnimationFrame(() => this.draw(image));
        },
        loadNewImage() {
            const image = new Image();
            image.src = this.currentJob.base64_output_images[this.currentIndex];
            image.onload = () => {
                this.cameraOffset.x = window.innerWidth / 2;
                this.cameraOffset.y = window.innerHeight / 2.5;
                this.zoom = 0.75;
                this.draw(image);
            };
        },
        onPointerDown(e) {
            this.isDragging = true;
            this.dragStart.x = this.getEventLocation(e).x / this.zoom - this.cameraOffset.x;
            this.dragStart.y = this.getEventLocation(e).y / this.zoom - this.cameraOffset.y;
        },
        onPointerUp() {
            this.isDragging = false;
        },
        onPointerMove(e) {
            if (this.isDragging) {
                this.cameraOffset.x = this.getEventLocation(e).x / this.zoom - this.dragStart.x;
                this.cameraOffset.y = this.getEventLocation(e).y / this.zoom - this.dragStart.y;
            }
        },
        handleTouch(e, singleTouchHandler) {
            if (e.touches.length === 1) {
                singleTouchHandler(e);
            } else if (e.type === 'touchmove' && e.touches.length === 2) {
                this.isDragging = false;
                handlePinch(e);
            }
        },
        handlePinch(e) {
            e.preventDefault();
            let initialPinchDistance = null;
            let touch1 = { x: e.touches[0].clientX, y: e.touches[0].clientY };
            let touch2 = { x: e.touches[1].clientX, y: e.touches[1].clientY };

            let currentDistance = (touch1.x - touch2.x) ** 2 + (touch1.y - touch2.y) ** 2;

            if (initialPinchDistance === null) {
                initialPinchDistance = currentDistance;
            } else {
                adjustZoom(null, currentDistance / initialPinchDistance);
            }
        },
        adjustZoom(zoomAmount, zoomFactor) {
            let lastZoom = this.zoom;
            if (!this.isDragging) {
                if (zoomAmount) {
                    this.zoom += zoomAmount;
                } else if (zoomFactor) {
                    this.zoom = zoomFactor * lastZoom;
                }

                this.zoom = Math.min(this.zoom, this.MAX_ZOOM);
                this.zoom = Math.max(this.zoom, this.MIN_ZOOM);
            }
        },
        getEventLocation(e) {
            if (e.touches && e.touches.length === 1) {
                return { x: e.touches[0].clientX, y: e.touches[0].clientY };
            } else if (e.clientX && e.clientY) {
                return { x: e.clientX, y: e.clientY };
            }
        },
        previousImage() {
            //if false means you are on the first image
            if (this.currentIndex > 0) {
                //go to prev image since current is not at the edge
                if (this.currentIndex > this.firstIndex) {
                    this.currentIndex--;
                    this.resetImageZoom();
                    this.loadNewImage();
                } else {
                    //go to prev image and move new images into the carousel
                    this.firstIndex--;
                    this.lastIndex--;
                    this.currentIndex--;
                    this.resetImageZoom();
                    this.loadNewImage();
                }
            }
        },
        nextImage() {
            //GO to next image since there are more images
            if (this.currentIndex < this.currentJob.base64_output_images.length - 1) {
                this.currentIndex++;
                this.resetImageZoom();
                this.loadNewImage();
                //You are on the last image tile, move in more tiles
                if (this.currentIndex === this.lastIndex) {
                    this.lastIndex++;
                    this.firstIndex++;
                    this.resetImageZoom();
                    this.loadNewImage();
                }
                // this.resetImageZoom();
            }
        },
        handleImagesToShow(i) {
            if (i >= this.firstIndex && i < this.lastIndex) {
                return true;
            }
        },

        handleZoom(e) {
            //ZOOM IN
            if (e.deltaY < 0) {
                if (this.zoom >= 0.25) {
                    this.zoom += this.zoomSpeed;
                    if (this.zoom > 3.75) this.zoom = 3.75;
                }
            } else {
                //ZOOM OUT
                let scale = this.zoom - this.zoomSpeed;
                if (scale >= 0.25) {
                    this.zoom -= this.zoomSpeed;
                } else {
                    //Stop Zoom out at half Original Image size
                    this.zoom = 0.25;
                }
            }
        },
        resetImageZoom() {
            this.zoom = 0.75;
            this.cameraOffset.x = window.innerWidth / 2;
            this.cameraOffset.y = window.innerHeight / 2.5;
        },
        handleZoomOnDbClick() {
            if (this.zoom === 0.75) {
                this.zoom = 1.75;
            } else {
                this.resetImageZoom();
            }
        },
        handleIncreaseZoom() {
            if (this.zoom === 4) return;
            switch (true) {
                case this.zoom < 0.5:
                    this.zoom = 0.5;
                    break;
                case this.zoom < 0.75:
                    this.zoom = 0.75;
                    break;
                case this.zoom < 1:
                    this.zoom = 1;
                    break;
                case this.zoom < 1.25:
                    this.zoom = 1.25;
                    break;
                case this.zoom < 1.5:
                    this.zoom = 1.5;
                    break;
                case this.zoom < 1.75:
                    this.zoom = 1.75;
                    break;
                case this.zoom < 2:
                    this.zoom = 2;
                    break;
                case this.zoom < 2.25:
                    this.zoom = 2.25;
                    break;
                case this.zoom < 2.5:
                    this.zoom = 2.5;
                    break;
                case this.zoom < 2.75:
                    this.zoom = 2.75;
                    break;
                case this.zoom < 3:
                    this.zoom = 3;
                    break;
                case this.zoom < 3.25:
                    this.zoom = 3.25;
                    break;
                case this.zoom < 3.5:
                    this.zoom = 3.5;
                    break;
                case this.zoom <= 3.75:
                    this.zoom = 3.75;
                    break;
                case this.zoom > 3.75:
                    this.zoom = 3.75;
                    break;
                default:
                    return this.zoom;
            }
        },
        handleDecreaseZoom() {
            switch (true) {
                case this.zoom <= 0.5:
                    this.zoom = 0.25;
                    break;
                case this.zoom <= 0.75:
                    this.zoom = 0.5;
                    break;
                case this.zoom <= 1:
                    this.zoom = 0.75;
                    break;
                case this.zoom <= 1.25:
                    this.zoom = 1;
                    break;
                case this.zoom <= 1.5:
                    this.zoom = 1.25;
                    break;
                case this.zoom <= 1.75:
                    this.zoom = 1.5;
                    break;
                case this.zoom <= 2:
                    this.zoom = 1.75;
                    break;
                case this.zoom <= 2.25:
                    this.zoom = 2;
                    break;
                case this.zoom <= 2.5:
                    this.zoom = 2.25;
                    break;
                case this.zoom <= 2.75:
                    this.zoom = 2.5;
                    break;
                case this.zoom <= 3:
                    this.zoom = 2.75;
                    break;
                case this.zoom <= 3.25:
                    this.zoom = 3;
                    break;
                case this.zoom <= 3.5:
                    this.zoom = 3.25;
                    break;
                case this.zoom <= 3.75:
                    this.zoom = 3.5;
                    break;
                default:
                    return this.zoom;
            }
        },
        //Navigate with arrow left and right buttons
        handleKeydown(e) {
            switch (e.keyCode) {
                case 37:
                    this.previousImage();
                    break;
                case 39:
                    this.nextImage();
                    break;
            }
        },

        //update image gallery index
        handleImageGalleryIndex(index){
            let oldSettings = this.getSettings();
            let newSettings = { ...oldSettings, image_gallery_index: index };

            this.updateSettings(newSettings);
        }
    },
    computed: {
        zoomLevel() {
            //shows zoom as 1 by default
            return `${Math.ceil((this.zoom + 0.25) * 100)}%`;
        },
    },
};
</script>
<style lang="scss" scoped>
canvas {
    height: calc(85% - 1.5rem);
    object-fit: cover;
}
.gallery-1 {
    height: 100%;
    gap: 10px;
    display: flex;
    flex-direction: column;
    padding: 10px;

    .gallery-row {
        height: calc(50% - 20px);
        gap: 10px;
        flex: 1;
    }

    .image {
        display: flex;
        gap: 10px;
        height: 100%;
        width: 100%;

        img {
            max-width: 100%;
            max-height: calc(85% - 1.5rem);
            width: auto;
            height: auto;
            object-fit: contain;
        }
    }
}
.main-image-container {
    height: calc(100% - 50px);
}
.main-image {
    cursor: zoom-in;
}
.carousel-container {
    height: 15%;
    position: absolute;
    z-index: 10;
    bottom: 0;
    // padding-bottom: 2.5rem;
    filter: drop-shadow(5px 5px 10px #000000f5);
}
.carousel-sub-container {
    gap: 10px;
    background-color: #222222;
    border-radius: 5px;
    padding: 5px;
    margin-bottom: 2.5rem;
}
.carousel-image-container {
    gap: 10px;
    width: 90%;
}
.carousel-image-sub-container {
    box-sizing: border-box;
    width: 25%;
    overflow: hidden;
    border-radius: 5px;
}
.carousel-image {
    object-fit: cover;
    align-items: center;
    overflow: hidden;
    width: 100%;
    border-radius: 5px;
}
.go-to-image {
    width: 5%;
}
.active-image {
    border: 2px solid #1266f1;
    border-radius: 5px;
    box-sizing: content-box;
}
.inactive-image {
    border: 2px solid;
    box-sizing: content-box;
}
.disbaled-icon {
    color: #6c757d;
}
.margin-left-76 {
    margin-left: 76.06px;
}
#viewport {
    width: 100%;
    height: 100%;
    cursor: grab;
}
</style>
